import { useMutation, useQueryClient } from "react-query";

import { makeRequest } from "@/util";
import {
  CURRENT_CONSENT_VERSION,
  type GetApprovalStatusResponse,
} from "@/api/ai-chat-approval";
import { ENDPOINTS } from "@/InsightsPage/constants";

export default function useApproveAiChat() {
  const queryClient = useQueryClient();
  return useMutation(
    async () => {
      const res = await makeRequest<GetApprovalStatusResponse>(
        "ai_chat_approve_usage",
        { consent_version: CURRENT_CONSENT_VERSION },
      );
      return res.data;
    },
    {
      onSuccess: (data) => {
        queryClient.setQueriesData<GetApprovalStatusResponse>(
          ["ai_chat_get_approval_status"],
          data,
        );
        void queryClient.invalidateQueries({
          queryKey: ["ai_chat_get_approval_status"],
        });
        void queryClient.invalidateQueries({
          queryKey: [ENDPOINTS.GET_RECOMMENDATION_CARDS],
        });
      },
    },
  );
}
